import { Component } from '@angular/core';

@Component({
  selector: 'placeme-chips-container',
  templateUrl: './chip-container.component.html',
  styleUrls: ['./chip-container.component.scss'],
})
export class ChipsContainerComponent {}
